/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-10-11 16:15:45
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-10-24 16:56:52
 */
import ColumnTypes from '@/utils/ColumnTypes';
import RdColumnTypes from '@/utils/RdColumnTypes';
const goodsInfo = {
	key: 'goodsInfo',
	label: '商品信息',
	type: () => import('./components/tableCells/goodsInfoCell.vue'),
	fixed: 'left',
	minWidth: '320',
};
const status = {
	label: '推广状态',
	type: () => import('./components/tableCells/promotionCell.vue'),
	key: 'activity_status_desc',
	minWidth: '120',
	isShow: true,
};
const goodsMechanism = {
	label: '商品机制',
	key: 'goodsMechanism',
	type: () => import('./components/tableCells/goodsMechanismCell.vue'),
	minWidth: '180',
	isShow: true,
};
const concactName = {
	key: 'submitName',
	label: '联系人',
	type: () => import('./components/tableCells/contactName.vue'),
	minWidth: '110',
};
const teamInfo = {
	key: 'teamInfo',
	label: '团长活动信息',
	type: () => import('./components/tableCells/teamInfoCell.vue'),
	minWidth: '240',
};
const views = {
	key: 'views',
	label: '商品浏览量',
	textType: 'num',
	type: () => import('./components/tableCells/numCell.vue'),
	minWidth: '100',
};
const signUp = {
	key: 'signUp',
	label: '商品报名数',
	textType: 'num',
	type: () => import('./components/tableCells/numCell.vue'),
	minWidth: '100',
};
const applyActivityNum = {
	key: 'applyActivityNum',
	label: '报名团长数',
	textType: 'num',
	type: () => import('./components/tableCells/numCell.vue'),
	minWidth: '100',
};
const authorityOrder = {
	key: 'authorityOrder',
	label: '动销团长数',
	textType: 'num',
	type: () => import('./components/tableCells/numCell.vue'),
	minWidth: '100',
};
const totalOrder = {
	key: 'totalOrder',
	label: '订单量',
	textType: 'num',
	type: () => import('./components/tableCells/numCell.vue'),
	minWidth: '100',
};
const totalAmount = {
	key: 'totalAmount',
	label: '销售额',
	textType: 'money',
	type: () => import('./components/tableCells/numCell.vue'),
	minWidth: '100',
};
const userName = {
	key: 'userName',
	label: '操作人',
	type: () => import('./components/tableCells/numCell.vue'),
	bigger: false,
	minWidth: '100',
};
const addTime = {
	key: 'addTime',
	label: '操作时间',
	type: () => import('./components/tableCells/numCell.vue'),
	minWidth: '180',
	bigger: false,
};
const operations = {
	key: 'operations',
	label: '操作',
	type: ColumnTypes.ButtonsCell,
	minWidth: '80',
	fixed: 'right',
	align: 'right',
};
export const dyColumns = [
	goodsInfo,
	status,
	goodsMechanism,
	concactName,
	teamInfo,
	views,
	signUp,
	applyActivityNum,
	authorityOrder,
	totalOrder,
	totalAmount,
	userName,
	addTime,
	operations,
];
export const ksColumns = [
	goodsInfo,
	status,
	goodsMechanism,
	concactName,
	teamInfo,
	views,
	signUp,
	applyActivityNum,
	authorityOrder,
	userName,
	addTime,
	operations,
];
